export default __webpack_public_path__ + "static/media/card800.d607e1d4.jpg";